export default {
    props: {
        templatesTemplateType: {
            type: String,
            kComposite: 'templates.template.type'
        }, 
        templatesTemplateTemplate: {
            type: String,
            kComposite: 'templates.template.template'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-popups-vue-wrapper/src/KendoNotification/Templates.js